(() => {
    window.dataLayer = window.dataLayer || [];
    function gtag() { dataLayer.push(arguments); }

    const ANALYTICS_STORAGE = "analytics_storage";
    const AD_STORAGE = "ad_storage";
    const AD_USER_DATA = "ad_user_data";
    const AD_PERSONALIZATION = "ad_personalization";
    const CONSENT_KEY = "user_cookie_consent";

    // Set default consent.
    gtag("consent", "default", {
        "analytics_storage": "denied",
        "ad_storage": "denied",
        "ad_user_data": "denied",
        "ad_personalization": "denied",
        "wait_for_update": 500
    });

    const updateGoogleAnalyticsConsent = (status) => {
        console.log(`Setting Google Analytics permission to ${status}.`);

        const consentState = {
            [ANALYTICS_STORAGE]: status,
            [AD_STORAGE]: status,
            [AD_USER_DATA]: status,
            [AD_PERSONALIZATION]: status,
        };

        gtag("consent", "update", consentState);
        localStorage.setItem(CONSENT_KEY, JSON.stringify(consentState));
    }

    const userHasAgreedToCookies = (() => {
        if (localStorage.getItem("soundgear-user-has-declined-cookies") === "true") {
            return false;
        }

        if (localStorage.getItem("soundgear-user-has-aggreed-to-cookies") === undefined) {
            return false;
        }

        if (localStorage.getItem("soundgear-user-has-aggreed-to-cookies") === "true") {
            return true;
        }

        return false;
    })();

    const userHasDeclinedCookies = (() => {
        if (localStorage.getItem("soundgear-user-has-declined-cookies") === "true") {
            return true;
        }

        if (localStorage.getItem("soundgear-user-has-aggreed-to-cookies") === undefined) {
            return false;
        }

        if (localStorage.getItem("soundgear-user-has-aggreed-to-cookies") === "true") {
            return false;
        }

        return false;
    })();

    if (userHasDeclinedCookies) {
        // Google permission will remain set to "denied".
        return;
    }

    if (userHasAgreedToCookies) {
        executeRB2B();
        updateGoogleAnalyticsConsent("granted");
        return;
    }

    // Beyond this point, this is the first time a user has visited the site.

    const cookieConsentBannerElement = document.querySelector(`#cookie-consent-banner`);
    const cookieDeclineButton = document.querySelector(`#cookie-consent-banner #cookie-decline-button`);
    const cookieConsentButton = document.querySelector(`#cookie-consent-banner #cookie-agree-button`);

    cookieConsentBannerElement.setAttribute("data-show-banner", "true");

    const handleConsentButtonClick = () => {
        localStorage.setItem("soundgear-user-has-aggreed-to-cookies", "true");
        localStorage.setItem("soundgear-user-date-agreed-to-cookies", new Date(Date.now()));
        cookieConsentBannerElement.removeAttribute("data-show-banner");

        executeRB2B();
        updateGoogleAnalyticsConsent("granted");
    }

    const handleDeclineButtonClick = () => {
        localStorage.setItem("soundgear-user-has-declined-cookies", "true");
        localStorage.setItem("soundgear-user-date-declined-to-cookies", new Date(Date.now()));
        cookieConsentBannerElement.removeAttribute("data-show-banner");
        updateGoogleAnalyticsConsent("denied");
    }

    cookieDeclineButton.addEventListener("click", handleDeclineButtonClick);
    cookieConsentButton.addEventListener("click", handleConsentButtonClick);
})();

// https://developers.google.com/tag-platform/security/guides/consent?consentmode=advanced#update-consent